module.exports = "/_next/static/images/aProDefaultLogo-1d62724fe09b5441bc078d6472abfdf0.png";